import { CSSProperties } from 'react';

export const stickyColumnSx = (side: 'right' | 'left'): CSSProperties => ({
  position: 'sticky',
  [side]: 0,
  backgroundColor: 'background.default',
});
